import { useContext } from "react";
import { AuthContext } from "../context/auth/auth";

// Create a custom hook for using the AuthContext
export const useAuthentication = () => {
  const context = useContext(AuthContext);
  //console.log("AuthContext:", context); 
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
